import { Control, FieldValues, UseFormSetValue } from "react-hook-form";

import { IFormAttributes, TTimeHHmm } from "@ryde/shared";

export interface IAvailabilityItem {
  from: TTimeHHmm;
  to: TTimeHHmm;
  dayTypeIds: number[];
  dayGroupIds: number[];
}

export interface IAvailabilityItemForm {
  fieldName: string;
  control?: Control;
  index?: number;
  onEdit?: () => void;
  onCancelOuter?: () => void;
  onEditStart?: () => void;
  onEditEnd?: () => void;
  value?: Partial<IAvailabilityItem>;
  setValueOuter?: UseFormSetValue<FieldValues>;
  removeHandler?: (index: number) => void;
  formAttributes?: IFormAttributes | null;
  disabledEdit?: boolean;
  disabledRemove?: boolean;
}

export const emptyAvailability: IAvailabilityItem = {
  from: "" as TTimeHHmm,
  to: "" as TTimeHHmm,
  dayTypeIds: [],
  dayGroupIds: [],
};

export const availabilityFormFieldNames: (keyof IAvailabilityItem)[] = [
  "from",
  "to",
  "dayTypeIds",
  "dayGroupIds",
];

export const availabilitySerialized = (item: IAvailabilityItem): string => {
  return `${item?.dayGroupIds?.join(",") || ""}-${item?.dayTypeIds?.join(",")} `;
};
